import React, { FC, useCallback, useEffect } from 'react';

import Modal from 'molecules/Modal';
import { ModalContent } from 'molecules/Modal/Modal.styles';
import PaymentScheduleTable from '.';
import axios from 'axios';

import { CloudOpsProjectsType } from 'pages/CompanyPage/types';

export const PaymentScheduleModal: FC<{
  project: CloudOpsProjectsType;
  onClose: () => void;
}> = ({ project, onClose }) => {
  const [currency, setCurrency] = React.useState<string | null>(null);

  const handleLogsClose = useCallback(() => {
    onClose();
    document.body.setAttribute('id', '');
  }, []);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_USER_SERVICE}/company/${project.company_hs_id}`
      )
      .then((response) => {
        const { data } = response;
        setCurrency(data.currency);
      });
  }, [project.company_hs_id]);

  if (!project || !currency) return <span />;

  return (
    <Modal
      open
      maxWidth="lg"
      title={`Payment Schedule for Project: ${project?.name || ''}`}
      subtitle={`This window provides a comprehensive breakdown of the payment schedule for the ${
        project?.company_name || ''
      }.`}
      onClose={handleLogsClose}
      sx={{ zIndex: 33333 }}
    >
      <ModalContent
        sx={{
          paddingBottom: '16px !important',
          maxHeight: '400px',
          overflow: 'hidden',
        }}
      >
        {project ? (
          <PaymentScheduleTable project={project} currency={currency} />
        ) : (
          '...'
        )}
      </ModalContent>
    </Modal>
  );
};
